var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "LuuDialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("changePassword.title"),
        width: "400px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "change-password-form" },
        [
          _c(
            "LuuForm",
            { ref: "changePasswordForm", attrs: { rules: _vm.rules } },
            [
              _c(
                "LuuFormItem",
                {
                  staticClass: "g-dialog__form-item",
                  attrs: { check: "oldPassword" },
                },
                [
                  _c("LuuInput", {
                    attrs: {
                      type: "password",
                      placeholder: _vm.$t("changePassword.oldPassword"),
                      "show-password": "",
                    },
                    model: {
                      value: _vm.form.oldPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "oldPassword", $$v)
                      },
                      expression: "form.oldPassword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "LuuFormItem",
                {
                  staticClass: "g-dialog__form-item",
                  attrs: { check: "newPassword" },
                },
                [
                  _c("LuuInput", {
                    attrs: {
                      type: "password",
                      placeholder: _vm.$t("changePassword.newPassword"),
                      "show-password": "",
                    },
                    model: {
                      value: _vm.form.newPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "newPassword", $$v)
                      },
                      expression: "form.newPassword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "LuuFormItem",
                {
                  staticClass: "g-dialog__form-item",
                  attrs: { check: "confirmPassword" },
                },
                [
                  _c("LuuInput", {
                    attrs: {
                      type: "password",
                      placeholder: _vm.$t("changePassword.confirmPassword"),
                      "show-password": "",
                    },
                    model: {
                      value: _vm.form.confirmPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "confirmPassword", $$v)
                      },
                      expression: "form.confirmPassword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "LuuFormItem",
                {
                  staticClass: "g-dialog__form-item",
                  attrs: { check: "googleCode" },
                },
                [
                  _c("LuuInput", {
                    attrs: { placeholder: _vm.$t("placeholder.google_code") },
                    model: {
                      value: _vm.form.googleCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "googleCode", $$v)
                      },
                      expression: "form.googleCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "change-password-actions" },
            [
              _c("LuuButton", {
                staticClass: "g-dialog__next",
                attrs: { loading: _vm.loading, label: "确定" },
                on: { click: _vm.handleSubmit },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }